<template>
    <entity-list
        entity="encounter"
        api-name="encounters"
        :use-events="true"
        :entity-sort="encounterSort"
        new-route-name="newEncounter"
        :event-id="eventId"
        :team-id="teamId"
        midTabShowSearch
        hideEventPicker
    >
        <template v-slot:[`currentList`]="{ entities, searchTerm, readRoute }">
            <v-data-table
                :headers="headers"
                :items="entities"
                :items-per-page="15"
                dense
                class="elevation-1"
                :search="searchTerm"
                :footer-props="{
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                }"
            >
                <template v-slot:[`item.name`]="{ item }">
                    <router-link :to="{ name: readRoute, params: { id: item.keyId } }" :title="item.name">
                        {{ item.name }}
                    </router-link>
                </template>
                <template v-slot:[`item.day`]="{ item }">
                    {{ getEncounterDayAndTime(item) }}
                </template>
            </v-data-table>
        </template>
    </entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
import { DateTime } from 'luxon'
import { sortBy } from 'lodash'
export default {
    name: 'EncounterList',
    components: {
        'entity-list': EntityList,
    },
    props: {
        eventId: {
            type: [String, Number],
            required: false,
        },
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
    data() {
        return {
            researchPeriods: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Date/Time',
                    align: 'start',
                    value: 'day',
                    width: '20%',
                },
                { text: 'Team', value: 'teamName', filterable: false, width: '15%' },
                { text: 'Status', value: 'statusText', filterable: false, width: '15%' },
            ],
        }
    },
    methods: {
        getEncounterDayAndTime(encounter) {
            return this.getTimeStamp(encounter.day.date, encounter.timeAsMinutes)
        },
        getTimeStamp(date, time) {
            if (!this.isValidDate(date)) return
            let dateOnly = DateTime.fromISO(date, { zone: 'utc' })
            if (!time) return `${dateOnly.toFormat('ccc')} - Floating`
            let dateTime = dateOnly.plus({ minutes: time })
            return `${dateOnly.toFormat('ccc')} ${dateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}`
        },
        isValidDate(value) {
            if (!value || value === 'Invalid DateTime' || (DateTime.isDateTime(value) && !value.isValid)) {
                return false
            }
            return true
        },
        encounterSort(encounters) {
            return sortBy(encounters, [
                'day.date',
                function(e) {
                    return e.timeAsMinutes ? e.timeAsMinutes : -1
                },
            ])
        },
        handleSlotSelected(day, time) {
            if (this.selectedEvent) {
                this.$router.push({
                    name: 'newEncounter',
                    params: { startingEvent: this.selectedEvent, startingDay: day, startingTime: time },
                })
            }
        },
    },
}
</script>
